export const SUPPORT_PAGE_SIZE = 20;
export const SUPPORT_SEARCH_FIELDS = ['ticketNumber', 'ticketId', 'userName', 'businessOwnerName'];

export const readSupportFilters = (search = '') => {
  const params = new URLSearchParams(search);
  return {
    status: params.get('status') || 'all',
    searchField: params.get('searchField') || 'ticketNumber',
    searchTerm: (params.get('search') || '').trim(),
    startDate: params.get('startDate') || '',
    endDate: params.get('endDate') || '',
    timeZone: params.get('timeZone') || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    ...Object.fromEntries(['replySource', 'resolutionMethod', 'needsReply']
      .filter((field) => params.has(field)).map((field) => [field, params.get(field)])),
  };
};

export const validateSupportFilters = (filters) => {
  if (!['all', 'open', 'closed'].includes(filters.status || 'all')) {
    throw new Error('Only Open and Closed status filters are supported by the verified ticket contract.');
  }
  if (!SUPPORT_SEARCH_FIELDS.includes(filters.searchField || 'ticketNumber')) {
    throw new Error('Choose a supported ticket search field.');
  }
  if (['replySource', 'resolutionMethod', 'needsReply'].some((field) => filters[field] && filters[field] !== 'all')) {
    throw new Error('Handling-source and substantive-answer filters need a trusted backend summary contract.');
  }
  if (filters.searchTerm && filters.searchField === 'ticketId' && filters.searchTerm.includes('/')) {
    throw new Error('A ticket ID must be one complete document ID without slashes.');
  }
  if (Boolean(filters.startAt) !== Boolean(filters.endAtExclusive)) {
    throw new Error('Choose both a start date and an end date.');
  }
  if (filters.startAt && (
    Number.isNaN(new Date(filters.startAt).getTime()) ||
    Number.isNaN(new Date(filters.endAtExclusive).getTime()) ||
    new Date(filters.startAt) >= new Date(filters.endAtExclusive)
  )) {
    throw new Error('Choose a valid date range with the end on or after the start.');
  }
};

export const supportTimestampToDate = (value) => {
  if (value == null) return null;
  const date = typeof value.toDate === 'function' ? value.toDate() : value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatSupportError = (error) => {
  const code = String(error?.code || '').replace(/^firestore\//, '');
  if (code === 'permission-denied' || code === 'unauthenticated') {
    return 'Ticket access was denied. Authorized Firebase authentication and Firestore rules must be configured for admin reads.';
  }
  if (code === 'failed-precondition') {
    return 'This filter combination needs Firestore index setup. Ask the backend team to configure the support query indexes.';
  }
  return 'Support ticket data could not be loaded. Please try again.';
};

export const supportReturnPath = (search = '') => `/support-tickets${search.startsWith('?') ? search : search ? `?${search}` : ''}`;

export const supportStatusLabel = (status) => {
  const value = String(status || 'unknown');
  return value.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};
